@import "styles/reset";
@import "styles/variables";
@import "styles/typography";

body {
  font-family: var(--font-stack-default);
  font-size: var(--font-size-medium);
  background-color: var(--color-black);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: space-around;
  -webkit-font-smoothing: antialiased;
}

.app {
  width: 100%;
  height: 100%;
}

.logo {
  display: block;
  margin: 0 auto;
  height: 41px;
  padding: 10px;
}
